import { render, staticRenderFns } from "./LayoutPrintA4.vue?vue&type=template&id=29ec803d&"
import script from "./LayoutPrintA4.vue?vue&type=script&lang=js&"
export * from "./LayoutPrintA4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports